import { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { closeTicketApi } from "../../api/agent/closeTicketApi";
import { useDispatch, useSelector } from "react-redux";
import { fetchTicketclose } from "../../../../modules/reducers/chat/agent/ticketClose";
import useReactGASend from "../../../../hooks/useReactGASend";
import { initChatStatus } from "#src/modules/reducers/chat/agent/connectChatServer.js";
import { initState } from "#src/modules/reducers/agreePrivacyTerm/agreePrivacy.js";
import queryString from "query-string";

const useChatControl = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [transferNumber, setTransferNumber] = useState(null);
  const [voiceAgentOpen, setVoiceAgentOpen] = useState(false);
  const [delayed, setDelayed] = useState({ delayed: false, message: "" });
  const [isOperating, setIsOperating] = useState({
    isOperating: false,
    message: "",
  });
  const [ticketClose, setTicketClose] = useState(false);
  const [survey, setSurvey] = useState(false);

  const [isCloseModalOpen, setIsCloseModalOpen] = useState(false);
  const [isSurveyModalOpen, setIsSurveyModalOpen] = useState(false);
  const [isVoiceAgentModalOpen, setIsVoiceAgentModalOpen] = useState(false);
  const [isLoadingModalOpen, setIsLoadingModalOpen] = useState(false);

  const ticketId = useSelector((state) => state.connectChatServer.ticketId);
  const { makeEventTrackFn } = useReactGASend();

  const dispatch = useDispatch();
  useEffect(() => {
    if (voiceAgentOpen) {
      openModal(setIsVoiceAgentModalOpen);
    }
  }, [voiceAgentOpen]);

  const openSurvey = () => {
    if (survey) {
      openModal(setIsSurveyModalOpen);
    } else if (transferNumber) {
      dispatch(initChatStatus());
      navigate("/landing");
    } else {
      dispatch(initChatStatus());
      navigate("/chat");
    }
  };

  const closeTicket = () => {
    const api = closeTicketApi();
    dispatch(fetchTicketclose({ ...api, data: { id: ticketId } }));
    dispatch(initState());
  };

  const openCloseChatModal = () => {
    openModal(setIsCloseModalOpen);
  };

  const closeCloseChatModal = () => {
    closeModal(setIsCloseModalOpen);
    handleTicketClose(true);
    closeTicket();
    openSurvey();
  };

  const openModal = (setModalState) => {
    setModalState(true);
  };

  const closeModal = (setModalState) => {
    setModalState(false);
  };

  const handleTransferNumberChange = (number) => {
    setTransferNumber(number);
    setVoiceAgentOpen(true);
  };

  const handleDelayed = (delayed) => {
    setDelayed(delayed);
  };

  const handleTicketClose = (ticketClose) => {
    if (ticketClose) {
      setTicketClose(ticketClose);
    }
  };

  const handleSurvey = (survey) => {
    if (survey) {
      setSurvey(true);
    }
  };

  const handleIsOperating = (isOperating) => {
    setIsOperating(isOperating);
  };

  const handleConnectChatCancle = () => {
    closeTicket();
    dispatch(initChatStatus());
  };

  useEffect(() => {
    openModal(setIsLoadingModalOpen);
  }, []);

  useEffect(() => {
    const queryParams = queryString.parse(location.search);
    if (queryParams.close) {
      openModal(setIsCloseModalOpen);
    } else {
      closeModal(setIsCloseModalOpen);
    }
  }, [location.search]);

  useEffect(() => {
    const handlePopState = () => {
      // openCloseChatModal();
      const currentPath = location.pathname + location.search;
      if (currentPath === "/chat/agent?close=true") {
        // 뒤로가기를 했을 때 /chat/agent로 이동
        navigate("/landing");
      } else {
        navigate("/chat/agent?close=true");
        handleSurvey(true);
        makeEventTrackFn({
          category: "event",
          action: "상담종료(고객 뒤로가기)",
        });
      }
    };
    setTimeout(() => {
      window.history.pushState(null, "", location.pathname);
      window.addEventListener("popstate", handlePopState);
    }, [500]);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [location.search]);

  useEffect(() => {
    // ticketClose시 ticket close dispatch
    if (ticketClose) {
      closeTicket();
    }
  }, [ticketClose]);

  return {
    openCloseChatModal,
    closeCloseChatModal,
    handleTransferNumberChange,
    handleDelayed,
    transferNumber,
    delayed,
    handleTicketClose,
    handleSurvey,
    openModal,
    ticketClose,
    handleIsOperating,
    isOperating,
    isCloseModalOpen,
    setIsCloseModalOpen,
    isSurveyModalOpen,
    setIsSurveyModalOpen,
    isVoiceAgentModalOpen,
    setIsVoiceAgentModalOpen,
    isLoadingModalOpen,
    setIsLoadingModalOpen,
    closeModal,
    handleConnectChatCancle,
  };
};

export default useChatControl;
